












import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "LoadingOverlay",
  props: {
    isLoading: { type: Boolean, required: true }
  }
});
